//const APIUrl = 'http://scvssvwb-p001.corp.sonance.com:8070'; //Dev
const APIUrl = 'https://vopayapi.sonance.com'; //Prod
 
//const APIUrl = 'http://172.31.27.129:8052'; //Prod
//const APIUrl = 'https://localhost:7293';//My local

export {APIUrl};